/**
 * Player Controls snippet
 * 
 * @author Mautilus s.r.o.
 * @class Snippet_PlayerControls
 * @extends Snippet
 */

Snippet_PlayerControls = (function(Snippet) {

	var Snippet_PlayerControls = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_PlayerControls.prototype, Snippet.prototype, {
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config){
			this.$lastFocused = null;

			this.Qmenu = this.parent.Qmenu;  // boolean
			this.maxSpeed = 32;    // max speed of ff or rw moving in the movie
			this.currentSpeed = 1; // current movie speed
			
			this.$title = this.$el.find('.player-title');
			// this.$title.hide();
			this.$time = this.$el.find('.time');
			this.$duration = this.$el.find('.duration');

			this.$speedIndicator = this.$el.find('.indicator');
			
			this.$btnPlay = this.$el.find('.btn-play');
			this.$btnFf = this.$el.find('.btn-ff');
            this.$btnRw = this.$el.find('.btn-rw');
			this.$btnLanguage = this.$el.find('.btn-language');
			this.$btnQmenu = this.$el.find('.btn-qmenu');

			this.$btnQmenu.toggle( this.Qmenu );
			this.$el.toggleClass( 'Q', this.Qmenu );
		},
		
		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(this.config.$el) {
				return this.config.$el;
			} else {
				return this.parent.$el.find(this.config.selector || "#snippet-player-controls");
			}
		},
		
		/**
		 * @inheritdoc Snippet#render
		 * @param {Object} movie (Asset Model)
		 */
		render: function(movie) {
			var hasSubtitles = !!(movie.subtitles && movie.subtitles.length);
			this.$title.html(movie.name);
			this.clear();
			hasSubtitles ? this.$btnLanguage.show() : this.$btnLanguage.hide();
			this.$btnLanguage.toggleClass( 'focusable', hasSubtitles );
			this.parent.playerProgressBarSnip.$el.toggleClass( 'no-subtitles-icon', !hasSubtitles );
		},

		/**
		 * @param {Number} time in miliseconds
		 */
		updateTime: function(time) {
			var timeStr = this.formatTime(time, { h: true, m: true, s: true });
			this.$time.html(timeStr);
		},
		
		/**
		 * @param {Number} duration in miliseconds
		 */
		updateDuration: function(duration) {
			var durationStr = this.formatTime(duration, { h: true, m: true, s: true });
			this.$duration.html(durationStr);
		},
		
		/**
		 * Change layout according to the actual player state
		 * @param {String} state of player
		 */
		updateButtons: function(state) {
			if (state === Player.STATE_PLAYING) {
				this.$btnPlay.children().removeClass('icon-play').addClass('icon-pause');
			}
			else if (state === Player.STATE_PAUSED) {
				this.$btnPlay.children().removeClass('icon-pause').addClass('icon-play');
			}
		},
		
		/**
		 * @private 
		 * @param {Number} time of player if undefined then is returned initial time [miliseconds]
		 * @returns {String} converted time
		 */
		formatTime: function(time, type) {
			if(!time){
				return '00:00:00';
			}
			var secs = parseInt(time, 10) / 1000;
			var hr  = type.h ? Math.floor(secs / 3600) : 0;
			var min = type.m ? Math.floor((secs - (hr * 3600))/60) : 0;
			var sec = type.s ? Math.floor(secs - (hr * 3600) - (min * 60)) : secs;

			if(type.h){
				if (hr < 10) {
					hr = "0" + hr;
				}
			}
			if(type.m){
				if (min < 10) {
					min = "0" + min;
				}
			}
			if(type.s){
				if (sec < 10) {
					sec = "0" + sec;
				}
			}
			return (type.h ? hr + ':' : '') + (type.m ? min + ':' : '') + (type.s ? sec : secs);
		},

		showSpeed: function(speed) {
			this.$speedIndicator.removeClass( 'speed' + this.currentSpeed );
			this.$speedIndicator.addClass( 'speed' + speed );
			this.$speedIndicator.show();
			this.currentSpeed = speed;
		},
		
		hideSpeed: function() {
			this.$speedIndicator.removeClass( 'speed' + this.currentSpeed );
			this.$speedIndicator.hide();
			this.currentSpeed = 1;
		},
		
		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			if(this.trigger('click', $el, event) === false) {
				return false;
			}
			return this.onEnter.apply(this, arguments);
		},

		handlePlayPause: function() {
			var PlayerScene = this.parent.parent;
			var PlayerUI = this.parent;
			if (PlayerUI.playerProgressBarSnip.$scrubber.hasClass("active")) {
				PlayerUI.playerProgressBarSnip.$scrubber.removeClass("active");
			}
			if ((Player.currentState === Player.STATE_PAUSED && Player.currentTime > 0) || (Player.currentState === Player.STATE_PLAYING && Player.speed != 1)) {
				PlayerScene.play();
			} else if ((Player.currentState === Player.STATE_PLAYING) && (Player.currentTime > 0)) {
				PlayerScene.pause();
			}
		},

		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			var control = $el.attr('data-id');
			var PlayerScene = this.parent.parent;
			var PlayerUI = this.parent;
			switch ( control ) {

				case 'play':
					this.handlePlayPause();
					break;
				case 'ff':
					if (Player.currentState === Player.STATE_PLAYING || (Player.currentState === Player.STATE_PAUSED && this.currentSpeed !== 1)) {
						if(!PlayerUI.playerProgressBarSnip.$scrubber.hasClass("active")) {
							PlayerUI.playerProgressBarSnip.$scrubber.addClass("active");
						}
						PlayerScene.ff();
					}
					break;

				case 'rw':
					if (Player.currentState === Player.STATE_PLAYING || (Player.currentState === Player.STATE_PAUSED && this.currentSpeed !== 1)) {
						if(!PlayerUI.playerProgressBarSnip.$scrubber.hasClass("active")) {
							PlayerUI.playerProgressBarSnip.$scrubber.addClass("active");
						}
						PlayerScene.rw();
					}
					break;

				case 'language':
					PlayerUI.playerSubtitlesSnip.show();
					PlayerUI.playerSubtitlesSnip.focus();
					break;

				case 'qmenu':
					Device.qmenu();
					break;

				default:
					break;
			}

			return false;
		},

		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function( direction ) {

			if (App.throbberIsShown) return false;

			switch ( direction ) {

				case 'up':
					this.trigger( 'focus:out', this, direction );
					break;

				case 'down':
					break;

				case 'left':
					this.parent.playerSubtitlesSnip.hide();
					Focus.to( this.getCircleFocusable( -1 ) );
					break;

				case 'right':
					Focus.isIn( this.$btnLanguage ) && this.parent.playerSubtitlesSnip.hide();
					Focus.to( this.getCircleFocusable( +1 ) );
					break;

				default:
					break;
			}
			return false;
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		focus: function( $el ) {
			if ( !$el ) {
				$el = this.$btnPlay;
			}
			return Focus.to( $el );
		},
		
		/**
		 * @inheritdoc Snippet#focus
		 */
		onFocus: function( $el ) {
			this.$lastFocused = $el;

			if ( $el.attr('data-id') === 'language' ) {
				 //this.parent.playerSubtitlesSnip.show();
			}
		},
		
		clear: function() {
			this.$lastFocused = null;
			
			this.$speedIndicator.hide();
			this.currentSpeed = 1;
			this.$title.html('');
			this.updateTime(0);
			this.updateDuration(0);
		},
		
		isFocusable: function() {
			return true;
		}
	});

	return Snippet_PlayerControls;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/player_controls.js
// module id = 70
// module chunks = 0